import { render, staticRenderFns } from "./block-sending.vue?vue&type=template&id=095de9d6&scoped=true"
import script from "./block-sending.vue?vue&type=script&lang=js"
export * from "./block-sending.vue?vue&type=script&lang=js"
import style1 from "./block-sending.vue?vue&type=style&index=1&id=095de9d6&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095de9d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('095de9d6')) {
      api.createRecord('095de9d6', component.options)
    } else {
      api.reload('095de9d6', component.options)
    }
    module.hot.accept("./block-sending.vue?vue&type=template&id=095de9d6&scoped=true", function () {
      api.rerender('095de9d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/advanced/components/setting-email/components/alert-user-answer/block-sending.vue"
export default component.exports